<template>
  <div
    class="module module-links padding_large"
    v-observe-visibility="visibilityChanged"
    :class="[
      { 'show-up': isVisible, 'bg-gray': data.theme === 'gray' },
      baseAnimation
    ]"
  >
    <ModuleContainer>
      <header v-if="data.title" class="module-heading-linked">
        <ModuleHeading>{{ data.title }}</ModuleHeading>
      </header>
      <ul v-if="data.type === 'links'" class="link-list">
        <li v-for="(link, i) in data.links" :key="i">
          <WrapperLink
            :class="[
              {
                'bg-gray': data.theme === 'white',
                external: !link.type && isExternal(link.link.url)
              },
              link.type ? 'link-file' : 'link-url'
            ]"
            :link="link.type ? 'file' : 'link'"
          >
            <AcfLink v-if="!link.type" :data="link.link" />
            <AcfFile v-else :data="link.file"></AcfFile>
          </WrapperLink>
        </li>
      </ul>
      <ul v-else class="link-navi" :class="'items-' + naviItems">
        <li v-if="data.navigation.prev" class="prev">
          <WrapperLink
            navigation="prev"
            :class="{ external: isExternal(data.navigation.prev.url) }"
          >
            <AcfLink :data="data.navigation.prev" />
          </WrapperLink>
        </li>
        <li v-if="data.navigation.next" class="next">
          <WrapperLink
            navigation="next"
            :class="{ external: isExternal(data.navigation.next.url) }"
          >
            <AcfLink :data="data.navigation.next" />
          </WrapperLink>
        </li>
      </ul>
    </ModuleContainer>
  </div>
</template>

<script>
import AcfLink from "@/components/elements/AcfLink";
import AcfFile from "@/components/elements/AcfFile";
import WrapperLink from "@/components/elements/WrapperLink";

import { isExternal } from "@/plugins/helpers.js";

export default {
  name: "links-module",
  props: ["data"],
  computed: {
    naviItems() {
      let items = "1";
      if (this.data.navigation.next && this.data.navigation.prev) items = "2";
      return items;
    }
  },
  components: {
    AcfLink,
    AcfFile,
    WrapperLink
  },
  methods: {
    isExternal: url => isExternal(url)
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.module-links {
  &.bg-gray {
    .long-links.link-wrapper {
      .text {
        a {
          background: #fff;
        }
      }
    }
  }
  .link-url,
  .dir-next {
    &.external .icon {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
  .dir-next {
    .text {
      text-align: right;
      a {
        padding-right: 70px !important;
      }
    }
  }
  .dir-prev {
    .text {
      text-align: left;
      a {
        padding-left: 70px !important;
      }
    }
    &.external .icon {
      transform: translateY(-50%) rotate(205deg) !important;
    }
  }
  .link-list,
  .link-navi {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    border-radius: 50px;
    height: 32px;
    width: 32px;
    svg {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 5px;
      left: 7px;
    }
  }
  .link-navi {
    .prev {
      text-align: right;
      .icon {
        right: auto;
        left: 20px;
        transform: translateY(-50%) rotate(180deg);
      }
      .text a {
        padding-left: 60px;
        padding-right: 20px;
        &:hover {
          //color: #fff !important;
        }
      }
      &:hover {
        .text a {
          //background-color: $fontColor;
        }
      }
    }
    .next {
      .text a {
        padding-right: 60px;
      }
      &:hover {
        .text a {
          //color: #fff;
          //background-color: $fontColor;
        }
      }
    }
    &.items-2 {
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
      li {
        max-width: 50%;
        width: 100%;
      }
    }
  }
  .link-list {
    .link-file {
      .icon {
        transform: rotate(90deg) translateX(-50%);
      }
    }
    li {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    a {
      &:hover {
        box-shadow: 0 0 10px 0 rgba(74, 79, 85, 0.5);
      }
    }
  }
  .icon svg g {
    transition: fill 0.12s ease-in-out;
  }
  a {
    transition: box-shadow 0.12s ease-in-out, background-color 0.12s ease-in-out,
      color 0.12s ease-in-out;
  }
}
</style>
